import {
  EXPENSE_AMOUNT_INPUT_METHOD,
  EXPENSE_DETAILED_ENTRY_MODE,
  EXPENSE_RATIO_INPUT_METHOD,
  EXPENSE_SUMMARIZED_ENTRY_MODE,
} from 'shared/constants/expenses';

const EXPENSE_ENTRY_MODE_OPTIONS = {
  [EXPENSE_DETAILED_ENTRY_MODE]: 'Detailed Entry',
  [EXPENSE_SUMMARIZED_ENTRY_MODE]: 'Summarized Entry',
};

export const EXPENSE_ENTRY_MODE_RADIO_BUTTON_ITEMS = Object.entries(EXPENSE_ENTRY_MODE_OPTIONS).map(
  ([acronym, fullString]) => ({
    value: acronym.toLowerCase(),
    label: fullString,
  })
);

export const EXPENSE_INPUT_METHOD_OPTIONS = {
  [EXPENSE_AMOUNT_INPUT_METHOD]: 'Amount',
  [EXPENSE_RATIO_INPUT_METHOD]: 'Ratio',
};

export const EXPENSE_INPUT_METHOD_RADIO_BUTTON_ITEMS = Object.entries(EXPENSE_INPUT_METHOD_OPTIONS).map(
  ([acronym, fullString]) => ({
    value: acronym.toLowerCase(),
    label: fullString,
  })
);

export const EXPENSE_AMOUNT_LABEL = 'Total Expenses ($)';
export const EXPENSE_RATIO_LABEL = 'Operating Expense Ratio (%)';
